module.exports = __webpack_public_path__ + "static/media/27-9.c0ac5eb5.mp3";